import React, { useEffect, useState } from "react";
import { getAllUserRoles } from "../../api/userRoleApi"; 
import { useNavigate } from "react-router-dom";

const ExistingUserRoles = () => {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const data = await getAllUserRoles(); // API should return your roles JSON
      setRoles(data);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  return (
    <div className="container-fluid p-3">
      
      {/* <h4>📜 Existing User Roles</h4> */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>📜 Existing User Roles</h5>
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
       </div>
      {/* <table className="table table-bordered mt-3">  */}
      <div className="allowance-table-container">
       <table className="allowance-table">
        <thead>
          <tr>
            <th>Sr</th>
            <th>User Name</th>
            <th>Full Name</th>
            <th>Role</th>
            <th>Active</th>
          </tr>
        </thead>
        <tbody>
          {roles.length > 0 ? (
            roles.map((u, idx) => (
              <tr key={u.userID}>
                <td>{idx + 1}</td>
                <td>{u.userName}</td>
                <td>{u.fullName}</td>
                <td>{u.roleName}</td>
                <td>{u.activateUser}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">No roles found.</td>
            </tr>
          )}
        </tbody>
      </table>
     </div>
    </div>
  );
};

export default ExistingUserRoles;
